<ax-button type="primary" size="sm" (onClick)="manageQuestion()" tooltip="Manage Question">
    <i class="fas fa-plus"></i>&nbsp;
    <span>Manage Question</span>
</ax-button>